import React, { Component } from "react";

import WidgetModal from "./../../widget/WidgetModal";
import WidgetAjax from "../../widget/WidgetAjax";
import Config from "../../config/Config";
import { ExclamationCircleFilled } from '@ant-design/icons';
import { Button, message } from 'antd';
import { Toast,Dialog } from 'antd-mobile'
import './../../css/frame.css';
import './../../css/project.css';
import './index.scss';

class Index extends Component {

    constructor(props) {
        super(props);

        this.state = {
            pageList: [],
            modelOptions: {
                type: 'message',
                title: '　',
                index: 0,
                message: null,
                isNext: false,
                isOk: true,
                wrapClassName: 'sg-index-model',
                bodyStyle: { padding: 0 },
            },
            modal: null,
            isHide: true,
            isUpdate: true,
            revokeInfo: {},
        }
        this.goSchedule.bind(this)
        this.onOk = this.onOk.bind(this);
    }
    componentDidMount() {
        this.querySqHisList()
        this.queryAuditMaxnewinfo();
    }
    querySqHisList() {
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/entsq/sq_HisList',
            params: {},
            callback: (data) => {
                if (data && data.status === 0) {
                    data.results.forEach(da => {
                        if (da.HJMC === '县审核') {
                            da.HJMC = '[县级]审核'
                        } else if (da.HJMC === '县报送') {
                            da.HJMC = '[县级]审核通过'
                        } else if (da.HJMC === '县审核驳回') {
                            da.HJMC = '[县级]驳回'
                        } else if (da.HJMC === '县审核退回') {
                            da.HJMC = '[县级]退回'
                        } else if (da.HJMC === '市报送') {
                            da.HJMC = '[市级]待审核'
                        } else if (da.HJMC === '市报送退回') {
                            da.HJMC = '[市级]退回'
                        } else if (da.HJMC === '市审核退回') {
                            da.HJMC = '[市级]退回'
                        } else if (da.HJMC === '市报送驳回') {
                            da.HJMC = '[市级]驳回'
                        } else if (da.HJMC === '省审核') {
                            da.HJMC = '[省级]待审核'
                        } else if (da.HJMC === '省报送驳回') {
                            da.HJMC = '[省级]驳回'
                        } else if (da.HJMC === '省审核驳回') {
                            da.HJMC = '[省级]驳回'
                        } else if (da.HJMC === '总局') {
                            da.HJMC = '认定入库'
                        } else {
                            da.HJMC = da.HJMC
                        }
                    })
                    this.setState({
                        pageList: data.results,
                    })
                }
            }
        }, this);

    };
    queryAuditMaxnewinfo() {
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/entsq/audit_maxnewinfo',
            params: {},
            callback: (data) => {
                if (data && data.status === 0) {
                    if (data.result && data.result.COUNTY) {
                        WidgetAjax.ajax({
                            url: Config.getBasePath() + '/businessSystem/setting',
                            params: {
                                SSQXID: data.result.COUNTY
                            },
                            callback: (res) => {

                                if (res && res.status == 0) {
                                    let isUpdate = true
                                    if (res.result.PSENDTIME && res.result.PSENDTIME != "") {
                                        let psendDate = new Date(res.result.PSENDTIME);  // 将时间字符串转换为 Date 对象
                                        const currentTime = new Date(); // 获取当前时间
                                        // 比较时间
                                        if (psendDate < currentTime) {
                                            isUpdate = false;      //超过评审期

                                        }

                                    }

                                    this.setState({ isUpdate, STATE: res.result.STATE })
                                }
                            }
                        }, this);
                    }

                }
            }
        }, this);
    }
    onChange(value) {
        console.log(value);
    };
    goSchedule(event) {
        let gradeNum = 0
        if (event.HJMC === '待审核') {
            gradeNum = 0
        } else if (event.HJMC.indexOf('县') !== -1) {
            gradeNum = 0
        } else if (event.HJMC.indexOf('市') !== -1) {
            gradeNum = 1
        } else if (event.HJMC.indexOf('省') !== -1) {
            gradeNum = 2
        } else {
            gradeNum = 3
        }
        this.props.history.push({ pathname: "/home/schedule", state: { SQID: event.SQID, HJMC: event.HJMC, gradeNum: gradeNum } });
    }
    goJudge(event) {
        this.props.history.push({ pathname: "/home/judge", state: { SQID: event.SQID, SFTJ: event.SFTJ } });
    }
    onRef = (ref) => {
        this.modal = ref;
    };
    reasonClick(res) {
        Dialog.alert({
            content: <div style={{ whiteSpace: "pre-line" }}>
                        <div>{res.SBZT === '2' ? '取消时间：' : '撤销时间：'}<span>{res.BGSJ}</span></div>
                        <div>{res.SBZT === '2' ? '取消原因：' : '撤销原因：'}<div>{res.MSG}</div></div>
                    </div>,
            onConfirm: () => {
                console.log('Confirmed')
            },
        })
    }
    onOk(type) {
        this.modal.onClose();
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/entsq/revoke',
            params: {
                SQID: this.state.revokeInfo.SQID
            },
            callback: (data) => {
                if (data && data.status === 0) {
                    Toast.show({
                        content: '撤销成功！',
                        maskClickable: false,
                    })
                    this.querySqHisList()
                }
            }
        }, this);
    }
    showModelBtn(res) {
        let { modelOptions } = this.state
        modelOptions.message = <div className="sg-index-body sd-columnCenter" style={{ padding: '0 0.1041rem ' }}>
            <ExclamationCircleFilled style={{ color: '#ff0000', fontSize: '38px' }} />
            <div style={{ marginTop: '12px' }}>请谨慎操作！</div>
            <div style={{ marginBottom: '28px' }}>一旦撤回将无法提交审核以及修改。</div>
        </div>
        this.modal.open();
        this.setState({
            revokeInfo: res
        })
    }
    fillingBtn() {
        localStorage.removeItem("_user_info_")
        localStorage.removeItem("_user_access_")
        this.props.history.push({ pathname: "/home/index", state: {} });
    }
    goHistory(event) {
        this.props.history.push({ pathname: "/home/notice", state: { SQID: event.SQID } });
    }
    render() {
        const { pageList, modelOptions, isHide, isUpdate, STATE } = this.state;

        return (
            <div data-component="notice">
                <div className="sg-notice" style={{ display: pageList && pageList.length ? 'block' : 'none' }}>
                    {
                        pageList && pageList.length && pageList.map((res, i) => {
                            console.log(['[县级]退回', '[市级]退回'].includes(res.HJMC), res.HJMC);
                            return <div className="sg-notice-list" key={i}>
                                <div className="sg-list-top">
                                    <div className="sg-list-title">{res.TASKNAME}</div>
                                    <div className="sg-list-start sd-start">
                                        <div className="sg-start-tips">申报状态：</div>
                                        {
                                            res?.SBZT === '2' || res?.SBZT === '3'
                                                ?
                                                <div>
                                                    <Button className="sg-tips-btn sg-color3">
                                                        {res.SBZT === '2' ? '取消认定' : '撤销认定'}
                                                    </Button>
                                                    <span style={{color: 'rgb(224, 32, 32)'}} onClick={() => { this.reasonClick(res) }}>（查看原因）</span>
                                                </div>
                                                :
                                                <Button className={`sg-tips-btn ${res.HJMC.indexOf('驳回') > -1 || res.HJMC.indexOf('退回') > -1 ? 'sg-color3' : ''} ${res.HJMC.indexOf('通过') !== -1 ? '' : ''}`}>
                                                    {['草稿'].includes(res.HJMC) ? '草稿' : ''}
                                                    {['[县级]审核', '[县级]审核通过', '[市级]待审核', '[省级]待审核', '待审核'].includes(res.HJMC) ? '待审核' : ''}
                                                    {['[县级]退回', '[市级]退回'].includes(res.HJMC) ? '退回' : ''}
                                                    {['[县级]驳回', '[市级]驳回', '[省级]驳回'].includes(res.HJMC) ? '驳回' : ''}
                                                    {['总局', '省审核通过', '认定入库'].includes(res.HJMC) ? '认定入库' : ''}
                                                </Button>

                                        }
                                    </div>
                                    <div className="sg-list-tips">申报时间：{res.creating_time}</div>
                                </div>


                                <div className="sg-list-right sd-spaceBetween" style={{ borderTop: '1px solid #DFE3E8' }}>
                                    <div className="sg-right-li sd-middle" >
                                        {
                                            res?.STATE === '0' ?
                                                <Button className="sg-right-btn" type="link" disabled={!['[县级]退回', '[市级]退回'].includes(res.HJMC)} onClick={() => { this.goJudge(res) }}>修改资料</Button>
                                                :
                                                <Button className="sg-right-btn" type="link" disabled={['[县级]审核通过', '[县级]驳回', '[市级]待审核', '[市级]驳回', '[省级]待审核', '[省级]驳回', '认定入库'].includes(res.HJMC) || isUpdate == false} onClick={() => { this.goJudge(res) }}>修改资料</Button>

                                        }
                                    </div>
                                    <div className="sg-right-li sd-middle">
                                        <Button className="sg-right-btn" type="link" disabled={['[县级]审核通过', '[县级]驳回', '[市级]待审核', '[市级]驳回', '[省级]待审核', '[省级]驳回', '认定入库'].includes(res.HJMC)} onClick={() => { this.showModelBtn(res) }}>撤销</Button>
                                    </div>
                                    <div className="sg-right-li sd-middle">
                                        <Button className="sg-right-btn" type="link" onClick={() => { this.goSchedule(res) }}>查看详情</Button>
                                    </div>
                                    <div className="sg-right-li sd-middle">
                                        <Button className="sg-right-btn" type="link" onClick={() => { this.goHistory(res) }}>申报通知</Button>
                                    </div>
                                </div>
                            </div>
                        })
                    }

                </div>
                <div className="sg-app-bottom sd-middle">
                    <div className="sg-bottom-btn sd-middle" onClick={() => { this.fillingBtn() }}>退出登录</div>
                </div>
                <div className="sg-notice" style={{ display: pageList && pageList.length ? 'none' : 'block' }}>
                    <div className="sg-notice-label sd-columnCenter">
                        <img className='sg-label-img11' alt='#' src={require('../../img/business/defined.png')} />
                        <div className="sg-label-font11">您还没有申报</div>
                    </div>
                </div>
                <WidgetModal options={modelOptions} onRef={this.onRef} isHide={isHide} onOk={this.onOk}></WidgetModal>
            </div >
        )
    }
}

export default Index
